/**
 * Format opportunity type labels for consistent display across the site
 */
export const formatTypeLabel = (type) => {
  const typeMap = {
    'Gigs': 'Gigs',
    'gigs': 'Gigs',
    'Full': 'Full Time',
    'full': 'Full Time',
    'Part': 'Part Time',
    'part': 'Part Time',
    'Temp': 'Temporary',
    'temp': 'Temporary',
    'Creative': 'Creative',
    'creative': 'Creative',
    'Editor': 'Editor',
    'editor': 'Editor',
    'Fellowship': 'Fellowship',
    'fellowship': 'Fellowship',
    'Internship': 'Internship',
    'internship': 'Internship',
    'Grant': 'Grant',
    'grant': 'Grant',
    'Unpaid': 'Unpaid',
    'unpaid': 'Unpaid'
  };
  
  return typeMap[type] || type;
};

/**
 * Format comma-separated opportunity types
 * Handles both single types and comma-separated types
 */
export const formatTypeLabels = (typesString) => {
  if (!typesString) return '';
  
  return typesString.split(',')
    .map(type => formatTypeLabel(type.trim()))
    .join(', ');
};
